export class SearchAllRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "types",
            "baseName": "types",
            "type": "Array<SearchAllType>",
            "format": ""
        },
        {
            "name": "providers",
            "baseName": "providers",
            "type": "Array<Provider>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllRequest.attributeTypeMap;
    }
    constructor() {
    }
}
